module.exports = __webpack_public_path__ + "img/contact.c33ccfc0.svg";